import { FC, useRef, useEffect, useCallback, MouseEventHandler } from 'react'
import s from './Modal.module.css'
import FocusTrap from '@lib/focus-trap'
import { Cross } from '@components/icons'
import {
  disableBodyScroll,
  clearAllBodyScrollLocks,
  enableBodyScroll,
} from 'body-scroll-lock'
interface ModalProps {
  className?: string
  children?: any
  onClose: () => void
  onEnter?: () => void | null
  modalMobileFullscreen?: boolean
  focusFirst?: boolean,
  hideCloseButton?: boolean
}

const Modal: FC<ModalProps> = ({ children, onClose, modalMobileFullscreen, focusFirst, hideCloseButton }) => {
  const ref = useRef() as React.MutableRefObject<HTMLDivElement>

  const handleKey = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        return onClose()
      }
    },
    [onClose]
  )

  useEffect(() => {
    const modal = ref.current

    if (modal) {
      disableBodyScroll(modal, { reserveScrollBarGap: true })
      window.addEventListener('keydown', handleKey)
    }
    return () => {
      if (modal) {
        enableBodyScroll(modal)
      }
      clearAllBodyScrollLocks()
      window.removeEventListener('keydown', handleKey)
    }
  }, [handleKey])

  const onBackdropClick: MouseEventHandler<HTMLDivElement> = (event) => {
    if ((event.target as HTMLElement)?.classList?.contains('backdrop')) {
      onClose();
    }
  };

  return (
    <div className={`${s.root} backdrop`} onClick={onBackdropClick}>
      <div className={`${s.modal} ${modalMobileFullscreen ? s.modalMobileFullscreen : ''}`} role="dialog" ref={ref} >
        { hideCloseButton !== true && <button
          onClick={() => onClose()}
          aria-label="Close panel"
          className={s.close}
        >
          <Cross className="h-6 w-6" />
        </button> }
        <FocusTrap focusFirst={focusFirst ?? true}>{children}</FocusTrap>
      </div>
    </div>
  )
}

export default Modal
